import React from 'react';
import { Link } from 'react-router-dom';
import { authService } from '../../../services/auth.service.ts';
import UserAvatar from '../../../components/UserAvatar.tsx';
import { getPlanLabel, getUserPlan } from '../../../utils/plan.ts';

function ProfileCard() {
  const user = authService.getUser();
  const userName = user?.name || 'Kullanıcı';
  const planLabel = getPlanLabel(getUserPlan(user));

  return (
    <div className="bg-white/5 backdrop-blur-sm rounded-xl border border-white/10 p-4 lg:p-6">
      {/* Mobil Layout */}
      <div className="flex flex-col sm:flex-row sm:items-center gap-4">
        {/* Avatar ve İsim */}
        <div className="flex items-center gap-4 flex-1">
          <UserAvatar
            src={user?.avatar}
            name={user?.name}
            email={user?.email}
            provider={user?.provider}
            showProviderBadge={!!user?.provider}
            sizeClass="w-16 h-16 sm:w-14 sm:h-14"
            className="shrink-0"
          />
          <div className="min-w-0">
            <h3 className="text-lg sm:text-xl font-bold text-white truncate">{userName}</h3>
            <p className="text-gray-400 text-sm">Plan: {planLabel}</p>
          </div>
        </div>

        {/* Butonlar */}
        <div className="flex flex-col gap-2 sm:items-end shrink-0">
          <Link
            to="/pricing"
            className="w-full sm:w-auto px-4 py-2 bg-purple-600 hover:bg-purple-700 text-white rounded-lg text-sm font-semibold transition text-center"
          >
            Planı Yönetin
          </Link>
          <Link
            to="/pricing"
            className="text-purple-400 hover:text-purple-300 text-sm transition text-center sm:text-right"
          >
            Plan Bilgilerini Görüntüle
          </Link>
        </div>
      </div>
    </div>
  );
}

export default ProfileCard;